'use client'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'
import moment from 'moment'
import { FC } from 'react'

import { BlogpostDataWithUid } from '@/app/(main)/resource-hub/page'
import { BlogAuthor, getAuthor, getValidatedCustomLabel } from '@/app/(main)/resource-hub/utils'
import BlogCard from '@/components/BlogCard'
import { RenderOn } from '@/utills/DeviceUtils'

export const CalloutArticles: FC<{
    relatedBlogPosts: BlogpostDataWithUid[]
    popularBlogPosts: BlogpostDataWithUid[]
    header: string
    authors: BlogAuthor[]
}> = ({ header, relatedBlogPosts, popularBlogPosts, authors }) => {
    // we want to show only three posts here, and related posts should be prioritised
    const blogPostsToShow = [...relatedBlogPosts, ...popularBlogPosts].slice(0, 3)

    return (
        <Stack spacing={{ xs: 6, sm: 6, md: 9 }}>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <RenderOn breakPoints={['md', 'lg', 'xl']}>
                    <Text variant={'h4'}>{header}</Text>
                </RenderOn>
                <RenderOn breakPoints={['xs', 'sm']}>
                    <Text variant={'h5'}>{header}</Text>
                </RenderOn>
            </Box>
            <Stack
                direction={{ xs: 'column', sm: 'column', md: 'row' }}
                spacing={{ xs: 5, sm: 5, md: 3 }}
            >
                {blogPostsToShow.map((blogpost, index) => {
                    return (
                        <BlogCard
                            size={'S'}
                            label={'Insight'}
                            customLabel={getValidatedCustomLabel(blogpost.custom_label)}
                            key={index}
                            sx={{ width: '100%' }}
                            href={`/blog/${blogpost.uid}`}
                            title={blogpost.title[0]!.text}
                            imageSrc={
                                'image' in blogpost.body[0]!.primary &&
                                blogpost.body[0]!.primary.image.url
                                    ? blogpost.body[0]!.primary.image.url
                                    : blogpost.main_image.url!
                            }
                            date={moment(blogpost.date, moment.ISO_8601, true)}
                            author={getAuthor(authors, blogpost.author)}
                        />
                    )
                })}
            </Stack>
        </Stack>
    )
}
